'use client';

import dynamic from 'next/dynamic';

export const MarketingChaeschtli = dynamic(
  () =>
    import(/* webpackChunkName: 'MarketingChaschtli' */ './MarketingChaeschtli.client').then(
      (mod) => mod.MarketingChaeschtli,
    ),
  {
    ssr: false,
  },
);
